export interface ServiceContent {
  id: string;
  icon: string;
  title: string;
  tagline: string;
  description: string;
  sectors: string[];
  capabilities: string[];
  clients: string[];
}

export const SERVICES_KEY = 'zobu_services_v1';

export const mockServicesContent: ServiceContent[] = [
  {
    id: 'management',
    icon: 'ri-line-chart-line',
    title: 'Management Consultancy',
    tagline: 'Know Yourself. Know Your Competition.',
    description:
      'A competent Chinese war master, Sun Tzu wrote "In peace prepare for war, in war prepare for peace" in the fifth century BC. Being prepared means knowing both yourself and your opponent. With Zobu Consulting\'s Management Consultancy, you gain the structured intelligence and strategic clarity to compete without damage. Since 2004, we have delivered competitive intelligence systems, market-entry strategies and organisational transformation programmes for private sector clients, development agencies and international organisations across Turkey, the Middle East and Europe.',
    sectors: [
      'Agri-Food & Value Chains',
      'Technology & Venture Capital (MENA)',
      'Energy & Industrial Holdings',
      'Financial Services & Investment',
      'Bilateral Trade & Foreign Direct Investment',
    ],
    capabilities: [
      'Competitive Intelligence System Design & Monitoring',
      'Market Entry & Positioning Strategy (Turkey, MENA, EU)',
      'Strategic Planning & Scenario Analysis',
      'Organisational Development & Governance Redesign',
      'Performance Management System Design',
      'Business Process Re-engineering',
      'Investment Climate Assessment & Benchmarking',
      'Change Management & Transformation Programmes',
      'Corporate Portfolio & Subsidiary Review',
      'Go-to-Market Strategy & Partner Ecosystem Mapping',
    ],
    clients: [
      'IFC / World Bank Group',
      'AHK Türkei (Turkish-German Chamber of Commerce)',
      'TechStart Ventures (UAE)',
      'Confidential Diversified Holding Group (Energy · Food · Real Estate)',
      'Malatya Apricot Producers\' Union / OKA',
    ],
  },
  {
    id: 'policy',
    icon: 'ri-government-line',
    title: 'Policy Development',
    tagline: 'Beyond Copy-Paste Strategies.',
    description:
      'Place-based implementations such as clusters, smart specialisation and value chain upgrading are the main tools of today\'s regional development strategies. At Zobu Consulting, we design and develop unique economic development strategies for public bodies that go far beyond the traditional industrial business attraction approach. Our policy advisory work spans Turkish development agencies, metropolitan municipalities and EU-funded programmes, always grounded in real economic geography, stakeholder consensus and measurable outcomes. From Bursa to Malatya, from İzmir to Ankara, every strategy is purpose-built for the territory it serves.',
    sectors: [
      'Regional Development Agencies (Kalkınma Ajansları)',
      'Metropolitan Municipalities',
      'Agri-Food & Rural Value Chains',
      'EU-Funded Programmes (IPA / ERDF Alignment)',
      'Smart Specialisation (S3) & Innovation Ecosystems',
      'Industrial Clustering & Sector Development',
    ],
    capabilities: [
      'Regional Economic Development Strategy (Place-Based)',
      'Industrial Clustering & Ecosystem Design',
      'Smart Specialisation (S3) Framework Development',
      'Agricultural Value Chain Upgrading & Policy',
      'EU Cohesion Policy Alignment & Advisory',
      'Investment Climate & Incentive Design',
      'Stakeholder Engagement & Consensus Facilitation',
      'Impact Monitoring & Evaluation Frameworks',
      'GI (Geographical Indication) Brand Positioning',
      'Regional Action Plans & Priority Investment Axes',
    ],
    clients: [
      'BEBKA (Bursa Eskişehir Bilecik Development Agency)',
      'OKA (North Anatolia Development Agency)',
      'İzmir Metropolitan Municipality',
      'Ankara Development Agency',
      'Malatya Kayısıcılar Birliği / OKA',
    ],
  },
  {
    id: 'engineering',
    icon: 'ri-building-2-line',
    title: 'Engineering Consultancy',
    tagline: 'Managing Complexity Beyond Managing a Project.',
    description:
      'Zobu Consulting offers full-spectrum engineering advisory services tailored to the unique requirements of each engagement. We manage complexity beyond project management, integrating seismic risk, feasibility economics, procurement integrity and quality systems across industrial, civil and mechanical disciplines. Our engineering assignments have covered major industrial facilities in the Marmara region, organised industrial zones in Central Anatolia, and renewable energy projects across Turkey. All feasibility work adheres to AACE International standards; all seismic assessments comply with TBDY-2018 and Eurocode 8.',
    sectors: [
      'Refining & Petrochemicals',
      'Organised Industrial Zones (OIZ)',
      'Renewable Energy: Wind and Solar',
      'Civil & Infrastructure Projects',
      'Industrial Facilities & Manufacturing',
    ],
    capabilities: [
      'Earthquake & Seismic Risk Assessment (TBDY-2018 / Eurocode 8)',
      'Business Continuity & Process Risk Analysis',
      'Feasibility Studies (AACE Class 3–5)',
      'CAPEX / OPEX Estimation & Reference-Class Forecasting',
      'Quality & Material Management Systems',
      'Technical Specification Preparation',
      'Procurement Strategy & Contract Management',
      'Organised Industrial Zone Master Planning & Advisory',
      'Bankable Financial Modelling (Wind, Solar, Industrial)',
      'Structural Retrofitting & Operational Resilience Planning',
    ],
    clients: [
      'TÜPRAŞ (Marmara Refinery)',
      'Ankara Development Agency (OIZ Programme)',
      'Green Anatolia Energy',
      'Industrial Corporates (Confidential)',
    ],
  },
];
